/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { AssetCard } from '../AssetCard';
import { sourceShape } from '../../../../../propsShape';

const SortableAssetCard = ({
  question,
  onRemove,
  retryQuestion,
  onClick,
  containerId,
  isReadOnly = false,
  sources = []
}) => {
  const { attributes, listeners, setNodeRef } = useSortable({
    id: question.id,
    data: { sortable: { containerId } }
  });
  return (
    <div ref={setNodeRef} data-id={question.id} {...attributes} {...listeners}>
      <AssetCard
        question={question}
        onRemove={onRemove}
        onClick={onClick}
        isReadOnly={isReadOnly}
        sources={sources}
        onRefresh={retryQuestion}
      />
    </div>
  );
};

SortableAssetCard.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  containerId: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(sourceShape),
  retryQuestion: PropTypes.func.isRequired
};

export { SortableAssetCard };
